import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, TextField } from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { TLLabelViewerModal } from "./TLLabelViewerModal";

const schema = yup.object({
  orderNumber: yup.string().required("Order number is required"),
});

type FormData = {
  orderNumber: string;
};

function OrderForm({ onSubmit, svgElement }: { onSubmit: (data: FormData) => void, svgElement: SVGSVGElement | null }) {
  const [open, setOpen] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormData>({
    resolver: yupResolver(schema),
  });

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      display="flex"
      alignItems="center"
      gap={2}
      sx={{ mb: 2 }}
    >
      <TextField
        label="Enter Order Number"
        variant="outlined"
        size="small"
        {...register("orderNumber")}
        error={!!errors.orderNumber}
        helperText={errors.orderNumber?.message}
      />
      <Button type="submit" variant="outlined" disabled={isSubmitting}>
        {isSubmitting ? "SEARCHING..." : "SEARCH"}
      </Button>

      <Button
          variant="outlined"
          onClick={() => setOpen(true)}
          disabled={!svgElement}
        >
          View Label
        </Button>

        <TLLabelViewerModal
                open={open}
                onClose={() => setOpen(false)}
                svgElement={svgElement}
              />
    </Box>
  );
}

export default OrderForm;
